<ng-container *ngIf="profileField$ | async as profileField">
    <ng-container *ngIf="(typedValues$ | async)?.length === 0">
        <ng-container *ngTemplateOutlet="emptyData; context: { profileField: profileField }"></ng-container>
    </ng-container>
    <ng-container *ngFor="let typedValue of typedValues$ | async">
        <ng-container *ngIf="typedValue.value?.length !== 0 && typeFieldDefinitions.get(typedValue.type)">
            <dt class="sh-description-list__term" [id]="profileField.FieldDefinition.DottedKey + '.' + typedValue.type" style="{{ nestedPadding$ | async }}">
                <sh-field-label
                    [label]="profileField.DisplayLabel + ' (' + (typeTranslations.get(typedValue.type) || typedValue.type) + ')'"
                    [labelIcons]="labelIcons"
                ></sh-field-label>
            </dt>
            <ng-container *ngIf="typeFieldDefinitions.get(typedValue.type) as typeFieldDef">
                <dd class="sh-description-list__details">
                    <ng-container
                        *ngTemplateOutlet="
                            canSearchOnClick(typeFieldDef) ? searchableData : nonSearchableData;
                            context: { values: typedValue.value, fieldDefinition: typeFieldDef }
                        "
                    >
                    </ng-container>
                </dd>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #searchableData let-values="values" let-fieldDefinition="fieldDefinition">
    <span *ngFor="let value of values; let index = index">
        <a class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, value)">{{ value }}</a>
        <ng-container *ngIf="index < values.length - 1">, </ng-container>
    </span>
</ng-template>

<ng-template #nonSearchableData let-values="values">
    <span *ngFor="let value of values; let index = index">{{ value }}<ng-container *ngIf="index < values.length - 1">, </ng-container></span>
</ng-template>

<ng-template #emptyData let-profileField="profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        {{ profileField.DisplayLabel }}
    </dt>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
